<template>
  <div class="tw-bg-white tw-rounded-md tw-p-8">
    <h5 class="tw-font-bold tw-text-center tw-mb-6 tw-text-[25px] tw-uppercase">
      Add New {{ type }}
    </h5>
    <validation-observer v-slot="{ invalid, handleSubmit }">
      <form
        @submit.prevent="handleSubmit(onSubmit)"
        class="tw-flex tw-flex-col tw-gap-4"
      >
        <span
          v-if="Object.keys(validationErrors).length > 0"
          class="tw-mb-5 tw-block tw-text-xs tw-text-error"
          >{{ validationErrors }}</span
        >
        <div class="tw-w-full">
          <validation-provider
            name="name"
            rules="required"
            v-slot="{ dirty, invalid, errors }"
          >
            <label for="name">Title</label>
            <input
              type="text"
              name="text"
              id="input"
              v-model="title"
              placeholder="Enter Title"
              :class="{
                error: dirty && invalid,
              }"
            />
            <small
              class="tw-text-error tw-block tw-text-[10px]"
              v-for="error in validationErrors.name"
              :key="error"
              >*{{ error }}</small
            >
            <span class="tw-text-xs tw-text-error" v-if="errors">{{
              errors[0]
            }}</span>
          </validation-provider>
        </div>

        <div class="tw-w-full" v-if="type == 'event'">
          <validation-provider
            name="name"
            rules="required"
            v-slot="{ dirty, invalid, errors }"
          >
            <label for="name">Event Date</label>
            <input
              type="date"
              name="text"
              id="input"
              v-model="event_date"
              placeholder="Enter Name of Hospital"
              :class="{
                error: dirty && invalid,
              }"
            />
            <small
              class="tw-text-error tw-block tw-text-[10px]"
              v-for="error in validationErrors.name"
              :key="error"
              >*{{ error }}</small
            >
            <span class="tw-text-xs tw-text-error" v-if="errors">{{
              errors[0]
            }}</span>
          </validation-provider>
        </div>

        <div class="tw-w-full">
          <validation-provider
            name="description"
            rules="required"
            v-slot="{ dirty, invalid, errors }"
          >
            <label for="username">Description</label>
            <!-- <textarea
              id="input"
              v-model="description"
              placeholder="Description"
              cols="30"
              rows="10"
              :class="{
                error: dirty && invalid,
              }"
            >
            </textarea> -->
            <client-only>
              <VueEditor :class="{
                error: dirty && invalid,
              }" v-model="description" />
            </client-only>
            <small
              class="tw-text-error tw-block tw-text-[10px]"
              v-for="error in validationErrors.description"
              :key="error"
              >*{{ error }}</small
            >
            <span class="tw-text-xs tw-text-error" v-if="errors">{{
              errors[0]
            }}</span>
          </validation-provider>
        </div>

        <div class="tw-w-full">
          <!-- <validation-provider
            name="profile photo"
            rules=""
            v-slot="{ errors }"
          > -->
          <label for="username">Image</label>
          <input @change="onFileChange" type="file" id="input" />
          <!-- <span class="tw-text-xs tw-text-error" v-if="errors">{{
              errors[0]
            }}</span> -->
          <small
            class="tw-text-error tw-block tw-text-[10px]"
            v-for="error in validationErrors.image"
            :key="error"
            >*{{ error }}</small
          >
          <!-- </validation-provider> -->
        </div>

        <div class="tw-mt-4 tw-text-center">
          <!-- <button
            class="veo-btn veo-primary tw-w-5/12"
          >
            <span>Add Enrollee</span>
          </button> -->

          <button
            class="veo-btn veo-primary tw-capitalize tw-w-5/12"
            v-bind:disabled="invalid || busy"
            :class="{ 'tw-bg-gray-400': invalid || busy }"
          >
            <span>{{ busy ? "..." : `Create ${type}` }}</span>
          </button>
        </div>
      </form>
    </validation-observer>

    <!-- Success Modal When Created  -->
    <el-dialog
      title="Success"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :show-title="false"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="tw-flex tw-flex-col tw-gap-2 tw-items-center">
        <i-icon
          icon="charm:circle-tick"
          class="tw-text-[80px] tw-text-primary-color"
        />
        <span class="tw-text-lg tw-font-bold tw-text-center"
          >Post Created <br />Successfully</span
        >
      </div>

      <span
        slot="footer"
        class="dialog-footer tw-flex tw-gap-2 tw-justify-center"
      >
        <button
          class="veo-btn veo-primary tw-py-2 tw-text-[10px] tw-px-2 tw-bg-blue-500"
          @click="resetForm"
        >
          Create New
        </button>
        <button
          @click="view"
          class="veo-btn capitalize veo-primary tw-py-2 tw-text-[10px] tw-bg-info tw-px-2"
        >
          View {{ type }}
        </button>
        <button
          @click="$router.go(-1)"
          class="veo-btn veo-primary tw-py-2 tw-text-[10px] tw-bg-success tw-px-2"
        >
          Go Back
        </button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      dataObj: {},
      title: "",
      profile_picture: "",
      description: "",
      event_date: "",
      dialogVisible: false,
      validationErrors: {},
      busy: false,
      query: this.$route.query,
      resPay: {},
    };
  },

  methods: {
    onSubmit() {
      let url =
        this.type == "event" ? this.$posts.addEvent : this.$posts.addPost;
      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("image", this.profile_picture);
      formData.append(
        "content",
        this.type !== "event" ? this.description : undefined
      );
      formData.append(
        "description",
        this.type == "event" ? this.description : undefined
      );
      formData.append(
        "event_date",
        this.type == "event" ? this.event_date : undefined
      );
      this.busy = true;
      url(formData)
        .then((res) => {
          console.log(res, "valid");
          this.dialogVisible = true;
          this.busy = false;
          this.resPay = res;
        })
        .catch((err) => {
          console.log(err);
          this.validationErrors = err.data.errors;
        })
        .finally(() => {
          this.busy = false;
        });
    },

    onFileChange(e) {
      var val = e.target.files[0];
      this.profile_picture = val;
    },

    view() {
      let data = String(this.resPay).split(":").shift();
      let link = data.split(" ").join("-");
      const slug = link.toLowerCase();
      let url = `/post/${slug}/view?uid=${this.resPay.id}&type=${this.type}`;
      this.$router.push(url);
    },

    resetForm() {
      this.handleClose();
    },

    handleClose() {
      this.dialogVisible = false;
    },
  },

  computed: {
    type() {
      return this.$route.query.type;
    },
  },
};
</script>

<style scoped>
/* El Dialog  */
.el-dialog__header {
  display: none;
}
</style>
